import { render, staticRenderFns } from "./weeklyDetails.vue?vue&type=template&id=1d39f642&scoped=true"
import script from "./weeklyDetails.vue?vue&type=script&lang=js"
export * from "./weeklyDetails.vue?vue&type=script&lang=js"
import style0 from "./weeklyDetails.vue?vue&type=style&index=0&id=1d39f642&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39f642",
  null
  
)

export default component.exports